import {all} from 'redux-saga/effects';
import usersSaga from '../users/redux/saga';

export default function* rootSaga(): Generator {
  yield all([usersSaga()]);
}
